import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ApolloClientProvider from "./ApolloClient";
import ShopifyAppBridgeProvider from "./Components/Shopify/ShopifyAppBridgeProvider";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import typography from "./Components/ThemeBuilding/TypographyTheme";
import palette from "./Components/ThemeBuilding/PaletteTheme";
import { AppProvider as PolarisAppProvider } from "@shopify/polaris";
import enTranslations from "@shopify/polaris/locales/en.json";
import "@shopify/polaris/build/esm/styles.css";

const theme = createTheme({
  palette: palette as any,
  typography: typography as any,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ShopifyAppBridgeProvider>
        <ApolloClientProvider>
          <PolarisAppProvider i18n={enTranslations}>
            <ThemeProvider theme={theme}>
              <App />
            </ThemeProvider>
          </PolarisAppProvider>
        </ApolloClientProvider>
      </ShopifyAppBridgeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
